import CustomCard from "../../components/CustomCard";
import {Badge} from "react-bootstrap";
import renderUtils from "../../helpers/renderUtils";
import React from "react";
import { useTranslation } from 'react-i18next';

export function MachineHeader(props) {
    const { t } = useTranslation();
    
    function content() {
        return <>
            <Badge variant={"primary"} className={"mr-2"}>
                {renderUtils.renderMachineType(props.machine, t)}
            </Badge>
            <Badge variant={"secondary"} className={"mr-2 font-max"}>
                {renderUtils.renderMachine(props.machine)}
            </Badge>

            <Badge variant={"primary"}>
                {props.packingLineName}
            </Badge>
        </>;
    }

    return <>
        {props.card == false ?
            <>
                {content()}
            </> :
            <CustomCard
                width={12}
                withoutHeader={true}>
                {content()}

            </CustomCard>
        }
    </>;
}